import React, { useEffect } from 'react'
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
  useNavigate
} from 'react-router-dom'
import MUIDataTable from 'mui-datatables'
import VisibilityIcon from '@mui/icons-material/Visibility'
import EditIcon from '@mui/icons-material/Edit'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { Stack } from '@mui/material'
import useTemplate from '../../hooks/useTemplate'
import DeleteTemplateModal from '../DeleteTemplateModal/DeleteTemplateModal'

// documentación MUIDataTable: https://www.npmjs.com/package/mui-datatables

const columns = [
  {
    name: 'Id',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'Name',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'Options',
    options: {
      filter: true,
      sort: true
    }
  }
]

const options = {
  download: false,
  print: false,
  viewColumns: false,
  selectableRowsHeader: false,
  selectableRowsHideCheckboxes: true
}

interface ListItemLinkProps {
  icon?: React.ReactElement
  to: string
}

function ListItemLink(props: ListItemLinkProps) {
  const { icon, to } = props

  const renderLink = React.useMemo(
    () =>
      React.forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'>>(
        function Link(itemProps, ref) {
          return (
            <RouterLink to={to} ref={ref} {...itemProps} role={undefined} />
          )
        }
      ),
    [to]
  )

  return (
    <ListItem button component={renderLink}>
      {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
      <ListItemText />
    </ListItem>
  )
}

function MuiTemplateTable() {
  const { fetchTemplates, templates, deleteTemplate } = useTemplate()

  useEffect(() => {
    fetchTemplates()
  }, [])


  const deleteAction = async (id:string) => {
    await deleteTemplate(id)
    fetchTemplates()
  }

  return (
    <MUIDataTable
      title={'Lista de plantillas'}
      options={options}
      data={templates.map((template) => {
        return [
          template.id,
          template.name,
          <Stack direction="row" sx={{ width: '20%' }}>
            <ListItemLink
              to={`/template/${template.id}`}
              icon={<VisibilityIcon />}
            />
            <ListItemLink
              to={`/template/update/${template.id}`}
              icon={<EditIcon />}
            />
            <DeleteTemplateModal action={() => deleteAction(template.id)} />
          </Stack>
        ]
      })}
      columns={columns}
    />
  )
}

export default MuiTemplateTable
